﻿import {translation} from "@2d-front-monorepo/core";
import {
	initializeMvvmContext,
	MvvmButton,
	MvvmDataProvider,
	toggleLoadingDialog
} from "@2d-front-monorepo/design-library";
import {
	AttachmentResult,
	ICreateComponentAttachments,
	PermitsMvvmErrorCollector,
	toFormData
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useHttpClient} from "../hooks/useHttpClient";
import {useProgressReport} from "../hooks/useProgressReport";
import {PermitsBackButton} from "./PermitsBackButton";
import UpdateAttachmentComponent from "./UpdateAttachmentComponent";

type UpdateDocumentationProps = {
	initialState: ICreateComponentAttachments;
	attachments: AttachmentResult[];
	onSubmit: () => Promise<void>;
}

export default function UpdateAttachmentsComponent({
	                                                   initialState,
	                                                   attachments,
	                                                   onSubmit
                                                   }: UpdateDocumentationProps): JSX.Element {

	const onFormSubmit = useCallback(async function (data: ICreateComponentAttachments): Promise<void> {
		try {
			const httpClient = useHttpClient();
			const progress = {current: 0, total: 0, label: ""};
			const progressReport = useProgressReport;
			const formData = await toFormData(httpClient, data.attachments, progress, progressReport);

			for (let {type, data} of formData) {
				++progress.current;
				progressReport(progress);
				const attachmentId = attachments.find(x => x.type === type)!.id;
				await httpClient.files.update(attachmentId, data);
			}

			await onSubmit();

		} finally {
			toggleLoadingDialog(false);
		}
	}, []);

	const context = initializeMvvmContext({
		initialState: initialState
	});

	return <MvvmDataProvider<ICreateComponentAttachments> onSubmit={onFormSubmit} context={context}>
		<h1>{translation(PermitTranslations.documentation_page__title)}</h1>
		<hr/>
		<div className="layout vertical gap">
			<PermitsMvvmErrorCollector/>
			{attachments.map(x => <UpdateAttachmentComponent key={x.id} context={context} attachment={x}/>)}
			<div className="form__buttons">
				<MvvmButton kind="primary">{translation(PermitTranslations.save_changes)}</MvvmButton>
				<span></span>
				<PermitsBackButton/>
			</div>
		</div>
	</MvvmDataProvider>;
}
